import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest } from '../../requestUtils';
import './NotInvoicingModal.scss';
var NotInvoicingModal = /*#__PURE__*/function (_Component) {
  function NotInvoicingModal(props) {
    var _this;
    _classCallCheck(this, NotInvoicingModal);
    _this = _callSuper(this, NotInvoicingModal, [props]);
    _this.state = {
      reason: props.reason
    };
    _this.handleNotInvoicing = _this.handleNotInvoicing.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(NotInvoicingModal, _Component);
  return _createClass(NotInvoicingModal, [{
    key: "handleNotInvoicing",
    value: function handleNotInvoicing() {
      var _this$props = this.props,
        invoiceId = _this$props.invoiceId,
        projectId = _this$props.projectId,
        consultantId = _this$props.consultantId,
        monthYear = _this$props.monthYear,
        csrfToken = _this$props.csrfToken,
        notInvoicingUrl = _this$props.notInvoicingUrl,
        redirectUrl = _this$props.redirectUrl;
      var reason = this.state.reason;
      postRequest(notInvoicingUrl, {
        resource_id: invoiceId,
        project_id: projectId,
        consultant_id: consultantId,
        start_date: monthYear,
        reason: reason
      }, csrfToken).then(function () {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          window.location.reload();
        }
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(reason) {
      this.setState({
        reason: reason
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        consultantName = _this$props2.consultantName,
        monthYear = _this$props2.monthYear,
        triggerType = _this$props2.triggerType,
        triggerText = _this$props2.triggerText,
        isConsultant = _this$props2.isConsultant;
      var reason = this.state.reason;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        submitButtonText: "Yes, Not Invoicing",
        cancelButtonText: "Cancel",
        handleSubmit: this.handleNotInvoicing,
        triggerType: triggerType,
        idKey: "not-invoicing",
        modalSize: "md"
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-3"
      }, "Why", isConsultant ? 'are you' : "is ".concat(consultantName), ' ', "not invoicing for", monthYear, "?"), /*#__PURE__*/React.createElement("textarea", {
        id: "reason",
        className: "form-control",
        value: reason,
        onChange: function onChange(e) {
          return _this2.handleChange(e.target.value);
        },
        placeholder: "No hours to submit..."
      })));
    }
  }]);
}(Component);
NotInvoicingModal.propTypes = {
  consultantName: PropTypes.string.isRequired,
  monthYear: PropTypes.string,
  reason: PropTypes.string,
  invoiceId: PropTypes.string,
  projectId: PropTypes.string,
  consultantId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  notInvoicingUrl: PropTypes.string.isRequired,
  triggerType: PropTypes.string,
  triggerText: PropTypes.string,
  isConsultant: PropTypes.bool,
  redirectUrl: PropTypes.string
};
NotInvoicingModal.defaultProps = {
  reason: null,
  invoiceId: null,
  monthYear: null,
  projectId: null,
  consultantId: null,
  triggerType: 'link',
  triggerText: 'Not Invoicing',
  isConsultant: false,
  redirectUrl: null
};
export default NotInvoicingModal;